import React from "react";
import {
  Grid,
  Card,
  CardMedia,
  CardContent,
  Avatar,
  Typography,
  Stack,
  CardActions,
  Button,
} from "@mui/material";
import { Link } from "react-router-dom";
import placeholderImg from "../../assets/images/placeholderLg.png";

export default function FeaturedProjectMobile({ id, name, type, overview }) {
  return (
    <Grid item>
      <Card sx={{ maxWidth: 290 }}>
        <CardMedia
          component="img"
          height="140"
          src={placeholderImg}
          alt="Gray placeholder"
        />
        <CardContent>
          <Grid container alignItems="center" pb={2} wrap="nowrap">
            <Grid item pr={2}>
              <Avatar></Avatar>
            </Grid>
            <Grid item xs={11}>
              <Stack>
                <Typography variant="h5" component="div">
                  {name}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {type}
                </Typography>
              </Stack>
            </Grid>
          </Grid>

          <Typography variant="body2" color="text.secondary">
            {overview}
          </Typography>
        </CardContent>
        <CardActions>
          <Button color="primary" variant="contained">
            <Link
              to={`/project/${id}`}
              state={{ id: id }}
              style={{
                color: "#FFFFFF",
                textDecoration: "none",
              }}
            >
              View Project
            </Link>
          </Button>
          <Button color="primary" variant="contained">
            Claim Project
          </Button>
        </CardActions>
      </Card>
    </Grid>
  );
}
